import request from '@/utils/request.js'

// 课程列表
function courseList(data) {
    return request({
        url: '/api/v1/tob/goods-course',
        method: 'get',
        params:data
    })
}

// 会员列表
function vipList(data) {
    return request({
        url: '/api/v1/tob/goods-member',
        method: 'get',
        params:data
    })
}

// 课程详情
function courseDetail(params) {
    return request({
        url: `/api/v1/tob/goods-chapter-show/${params.id}`,
        method: 'get',
        params
    })
}

// 会员详情
function vipDetail(params) {
    return request({
        url: `/api/v1/tob/goods-member-detail/${params.id}`,
        method: 'get',
        params
    })
}

// 修改商品价格
function updateGoodsPrice(data) {
    return request({
        url: "/api/v1/tob/update-goods-price",
        method: 'post',
        data
    })
}

// 科目列表
function subjectsList(params) {
    return request({
        url: `/api/v1/subjects_list`,
        method: 'get',
        params
    })
} 

// 查看已开通学员
function tobGPowerUser(data) {
    return request({
        url: `/api/v1/tob/tob-good-power-user`,
        method: 'get',
        params:data
    })
} 

// 学员添加课程
function addCoursePower(data) {
    return request({
        url: "/api/v1/tob/add-course-power",
        method: 'post',
        data
    })
}

// 学员添加套餐
function addPackagePower(data) {
    return request({
        url: "/api/v1/tob/add-package-power",
        method: 'post',
        data
    })
}


// 学员添加会员
function addMemberPower(data) {
    return request({
        url: "/api/v1/tob/add-member-power",
        method: 'post',
        data
    })
}

// 【机构后台】未开通会员的学员信息
function getNoPowerStudent(data) {
    return request({
        url: `/api/v1/tob/no-power-student`,
        method: 'get',
        params:data
    })
} 


// 单个用户开通多个商品
function userAddMemberPowe(data) {
    return request({
        url: "/api/v1/tob/user-add-member-power",
        method: 'post',
        data
    })
}

function getGoodsPackage(data) {
    return request({
        url: `/api/v1/tob/goods-package`,
        method: 'get',
        params:data
    })
} 

function getPackageList(data) {
    return request({
        url: `/api/v1/tob/goods-package`,
        method: 'get',
        params:data
    })
} 


function getTobLevels(data) {
    return request({
        url: `/api/v1/tob/levels`,
        method: 'get',
        params:data
    })
} 

function getTobHideMenu(data) {
    return request({
        url: `/api/v1/tob/hidemenu`,
        method: 'get',
        params:data
    })
} 

function getTobOpenExams(data) {
    return request({
        url: `/api/v1/tob/openexams`,
        method: 'get',
        params:data
    })
} 


// 推广工具  /api/v1/tob/promotion
function getPromotion(data) {
    return request({
        url: '/api/v1/tob/promotion',
        method: 'get',
        params:data
    })
}

// 推广老师解绑
function teacherUnbind(data) {
    return request({
        url: "/api/v1/tob/teacher/unbind",
        method: 'post',
        data
    })
}
// 推广老师升级
function teacherUpgrade(data) {
    return request({
        url: "/api/v1/tob/teacher/upgrade",
        method: 'post',
        data
    })
}


// 【机构后台】获取提示消息 /api/v1/tob/tip-message-info
function getTobTipMessageInfo(data) {
    return request({
        url: '/api/v1/tob/tip-message-info',
        method: 'get',
        params:data
    })
}

// 【机构后台】关闭提示 /api/v1/tob/tip-message-colse
function tipMessageColse(data) {
    return request({
        url: "/api/v1/tob/tip-message-colse",
        method: 'post',
        data
    })
}

// 批量取消订单 /api/v1/tob/order/batch
function tobOrderBatch(data) {
    return request({
        url: "/api/v1/tob/order/batch",
        method: 'post',
        data
    })
}

// 更新商品状态 /api/v1/tob/good-update-status
function tobGoodUpdateStatus(data) {
    return request({
        url: "/api/v1/tob/good-update-status",
        method: 'post',
        data
    })
}

// 机构后台_公告弹窗列表 /api/v1/tob/notice-popup-list
function getTobNoticePopupList(data) {
    return request({
        url: '/api/v1/tob/notice-popup-list',
        method: 'get',
        params:data
    })
}

// 机构后台_公告弹窗改已弹窗 /api/v1/tob/notice-popup-yes
function resetExamType(data) {
    return request({
        url: `/api/v1/tob/notice-popup-yes`,
        method: 'post',
        data
    })
}
// 升级的商品列表
function upgradeGoodsList(data) {
    return request({
        url: `/api/v1/tob/upgrade-good-list/${data.order_id}`,
        method: 'get',
        params:data
    })
}





export default {
    courseList,
    courseDetail,
    updateGoodsPrice,
    subjectsList,
    vipList,
    addCoursePower,
    addPackagePower,
    addMemberPower,
    userAddMemberPowe,
    tobGPowerUser,
    vipDetail,
    getGoodsPackage,
    getPackageList,
    getTobLevels,
    getTobHideMenu,
    getTobOpenExams,
    getPromotion,
    teacherUnbind,
    teacherUpgrade,
    getTobTipMessageInfo,
    tipMessageColse,
    getNoPowerStudent,
    tobOrderBatch,
    tobGoodUpdateStatus,
    getTobNoticePopupList,
    resetExamType,
    upgradeGoodsList 
}